import axios from "@/api/axiosInstance";
import { FetchAccountsByAccountingIdsResponse } from "./types";

export const fetchAccountsByAccountingIds = async (
  corporationName: string,
  accountingIds: string[],
): Promise<FetchAccountsByAccountingIdsResponse> => {
  const response = await axios.get<FetchAccountsByAccountingIdsResponse>(
    `/api/private/corporation/${corporationName}/accounts/accountingId/${accountingIds.join(",")}`,
  );
  return response.data;
};
